import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/NotifyTypes/Get`, payload),
}
